import { useEffect, useState } from "react";
import { pnpLogo } from "../../../Asserts";
import useDeviceType from "../../../Utiles/FindDevice";
import { putData } from "../../../services/api";
import { useNavigate } from "react-router";
import { useLocation } from "react-router-dom";
import axios from "axios";
import { baseURL } from "../../../services/axiosConfig";
import { toast } from "react-toastify";
import Button from "../../../Components/Auth/Button";
import {
  FooterTab,
  MobileFooter,
} from "../../../../Components/GreenHome/Footer";

const Leagues = () => {
  const deviceType = useDeviceType();
  const navigate = useNavigate();
  const [gamesList, setGamesList] = useState([]);
  const [leaguesList, setLeaguesList] = useState([]);
  const [selectedGames, setSelectedGames] = useState([]);
  const [selectedLeagues, setSelectedLeagues] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const location = useLocation();

  const userEmail = location?.pathname?.split("/")?.pop();

  useEffect(() => {
    const fetchGames = async () => {
      try {
        const games = await axios.get(`${baseURL}/pot/games/?status=true`);
        setGamesList(games?.data?.data || []);
      } catch (error) {
        setGamesList([]);
      }
    };

    fetchGames();
  }, []);

  const getLeaguesBasedOnGames = async (gameIds) => {
    try {
      const response = await axios.get(
        `${baseURL}/pot/preferredleagues/?status=active&game_ids=${gameIds.join(
          ","
        )}`
      );
      setLeaguesList(response?.data || []);
    } catch (error) {
      console.error("Error fetching leagues:", error);
      setLeaguesList([]);
    }
  };

  const userInfo = JSON.parse(localStorage.getItem("user"));
  const userId = userInfo;

  useEffect(() => {
    if (selectedGames.length > 0) {
      getLeaguesBasedOnGames(selectedGames);
    } else {
      setLeaguesList([]);
      setSelectedLeagues([]);
    }
  }, [selectedGames]);

  const handleSubmit = async () => {
    try {
      const res = await axios.put(
        `${baseURL}/accounts/user/interests/${userId}/`,
        {
          interested_games: selectedGames,
          interested_leagues: selectedLeagues,
        }
      );
      console.log("Submit response:", res);
    } catch (error) {
      console.error("Error submitting leagues:", error);
    }
  };

  useEffect(() => {
    if (leaguesList.length > 0) {
      setSelectedLeagues((prev) =>
        prev.filter((leagueId) =>
          leaguesList.some((league) => league.id === leagueId)
        )
      );
    }
  }, [leaguesList]);

  const handleNext = async () => {
    if (selectedGames.length === 0 && selectedLeagues.length === 0) {
      alert("Please select at least one game or league to continue.");
      return;
    }

    setIsLoading(true);
    try {
      handleSubmit();
      navigate(`/emailVerification/${userEmail}`, {
        state: { from: "leagues" },
      });
    } catch (error) {
      console.error("Error saving preferences:", error);
      alert("There was an error saving your preferences. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  const skippingLeagueSelection = () => {
    navigate(`/emailVerification/${userEmail}`);
  };

  const getLeaguePlaceholder = (name) => {
    return `image/svg+xml,${encodeURIComponent(`
      <svg width="40" height="40" viewBox="0 0 40 40" xmlns="http://www.w3.org/2000/svg">
        <rect width="40" height="40" fill="#E5E7EB"/>
        <text x="50%" y="50%" font-family="Arial" font-size="12" fill="#6B7280" text-anchor="middle" dy=".3em">
          ${name.substring(0, 2)}
        </text>
      </svg>
    `)}`;
  };

  const selectedBorderStyle = {
    border: "2.5px solid transparent",
    backgroundImage:
      "linear-gradient(white, white), linear-gradient(135deg, #3B82F6, #22C55E)",
    backgroundOrigin: "border-box",
    backgroundClip: "padding-box, border-box",
    boxShadow: "0 2px 8px rgba(34,197,94,0.1), 0 1px 4px rgba(59,130,246,0.1)",
  };
  const unselectedBorderStyle = {
    border: "2px solid #D1D5DB",
    boxShadow: "0 1px 4px rgba(0,0,0,0.04)",
  };

  return (
    <div
      style={{
        backgroundImage: `url('/v2/images/bg/${
          deviceType === "mobile" ? "auth-bg-mobile.png" : "auth-bg.png"
        }')`,
      }}
      className="bg-cover bg-no-repeat bg-center"
    >
      <div
        className={`w-full min-h-screen flex ${
          deviceType === "mobile"
            ? "flex-col items-center py-8 px-4"
            : "lg:flex-row items-start px-24 py-20"
        } `}
      >
        {deviceType !== "mobile" && (
          <div className="text-white">
            <img src={pnpLogo} alt="Logo" className="lg:h-32 mb-6 lg:-my-6" />
          </div>
        )}

        <div
          className={`w-full  ${
            deviceType === "mobile" ? "max-w-md" : "max-w-4xl ml-auto"
          }`}
        >
          {deviceType === "mobile" && (
            <img
              src={pnpLogo}
              alt="Logo"
              className="h-20 w-auto mb-6 mx-auto"
            />
          )}

          <div className="bg-white rounded-xl overflow-hidden">
            <div className="h-1.5 bg-gradient-to-r from-[#00C05B] to-[#007FFF]" />

            <div className="p-4">
              {/* Games Section */}
              <div className="mb-10">
                <h2 className="text-md md:text-xl font-bold text-black mb-6 font-archivo">
                  Select your favourite sports
                </h2>
                {/* 
                On mobile (tailwind default): grid-cols-3
                On small screens (sm): grid-cols-3
                On large (lg): grid-cols-5
              */}
                <div className="grid grid-cols-3 sm:grid-cols-3 lg:grid-cols-5 gap-2">
                  {gamesList?.length > 0
                    ? gamesList?.map((game) => (
                        <button
                          key={game.id}
                          onClick={() => {
                            const isCurrentlySelected = selectedGames.includes(
                              game.id
                            );
                            if (isCurrentlySelected) {
                              const updatedGames = selectedGames.filter(
                                (id) => id !== game.id
                              );
                              setSelectedGames(updatedGames);
                              if (updatedGames.length === 0) {
                                setSelectedLeagues([]);
                              }
                            } else {
                              setSelectedGames((prev) => [...prev, game.id]);
                            }
                          }}
                          className={`relative flex flex-col items-center justify-center p-4 rounded-xl transition-all duration-200 bg-white
                      ${
                        deviceType === "mobile" || deviceType === "tablet"
                          ? "h-21"
                          : "h-48"
                      }`}
                          style={
                            selectedGames.includes(game.id)
                              ? selectedBorderStyle
                              : unselectedBorderStyle
                          }
                        >
                          <div
                            className={`rounded-lg flex items-center justify-center ${
                              deviceType === "mobile" ? "py-1" : "py-2"
                            }`}
                          >
                            {game?.logo ? (
                              <img
                                src={game?.logo}
                                alt={game?.game_name}
                                className={
                                  deviceType === "mobile"
                                    ? "w-9 h-8 object-contain"
                                    : "w-10 h-10 object-contain"
                                }
                              />
                            ) : (
                              <span
                                className={`text-gray-400 font-semibold ${
                                  deviceType === "mobile"
                                    ? "text-xs"
                                    : "text-lg"
                                }`}
                              >
                                {game?.game_name?.substring(0, 2)}
                              </span>
                            )}
                          </div>
                          <span
                            className={`font-semibold text-black ${
                              deviceType === "mobile"
                                ? "text-[10px]"
                                : "text-lg"
                            } text-center`}
                          >
                            {game?.game_name}
                          </span>
                          {selectedGames.includes(game.id) && (
                            <div className="absolute -top-3 -right-3 w-7 h-7 rounded-full bg-[#0081F8] flex items-center justify-center border-2 border-white shadow">
                              <svg
                                className="w-4 h-4 text-white"
                                viewBox="0 0 20 20"
                                fill="none"
                              >
                                <path
                                  d="M6 10l3 3 6-6"
                                  stroke="#fff"
                                  strokeWidth="2"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                              </svg>
                            </div>
                          )}
                        </button>
                      ))
                    : Array.from({ length: 4 }).map((_, index) => (
                        <div
                          key={index}
                          className="h-48 rounded-xl bg-gray-100 animate-pulse"
                        />
                      ))}
                </div>
              </div>
              {/* Leagues Section */}
              <div className="mb-10">
                <h2 className="text-md md:text-xl font-bold text-black mb-6 font-archivo">
                  Select your preferred leagues
                </h2>
                <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
                  {leaguesList?.length > 0 ? (
                    leaguesList?.map((league) => (
                      <button
                        key={league.id}
                        onClick={() => {
                          setSelectedLeagues((prev) =>
                            prev.includes(league.id)
                              ? prev.filter((id) => id !== league.id)
                              : [...prev, league.id]
                          );
                        }}
                        className="relative flex flex-col items-center justify-center h-16 px-4 rounded-xl transition-all duration-200 bg-white"
                        style={
                          selectedLeagues.includes(league.id)
                            ? selectedBorderStyle
                            : unselectedBorderStyle
                        }
                      >
                        <div className="w-[80%] h-[h-75%] mb-1 mx-auto flex items-center justify-center">
                          {league?.logo_url ? (
                            <img
                              src={league?.logo_url}
                              alt={league?.name}
                              className="object-contain w-[60%] h-[55%] rounded"
                            />
                          ) : (
                            <img
                              src={getLeaguePlaceholder(league?.name)}
                              alt={league?.name}
                              className="w-[60%] h-[50%] object-contain rounded"
                            />
                          )}
                        </div>
                        {selectedLeagues.includes(league.id) && (
                          <div className="absolute -top-3 -right-3 w-7 h-7 rounded-full bg-[#0081F8] flex items-center justify-center border-2 border-white shadow">
                            <svg
                              className="w-4 h-4 text-white"
                              viewBox="0 0 20 20"
                              fill="none"
                            >
                              <path
                                d="M6 10l3 3 6-6"
                                stroke="#fff"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            </svg>
                          </div>
                        )}
                      </button>
                    ))
                  ) : selectedGames.length === 0 ? (
                    <div className="col-span-full text-center py-8 text-gray-500">
                      Please select a sport to see the available leagues.
                    </div>
                  ) : leaguesList?.length === 0 ? (
                    <div className="col-span-full text-center py-8 text-gray-500">
                      No leagues available for the selected sports.
                    </div>
                  ) : (
                    <div className="col-span-full text-center py-8 text-gray-500">
                      Loading leagues for selected sports...
                    </div>
                  )}
                </div>
              </div>

              {/* Action Buttons */}
              <div className="flex gap-4">
                <Button
                  type="button"
                  text={`Next (${
                    selectedGames.length + selectedLeagues.length
                  })`}
                  onClick={handleNext}
                  loading={isLoading}
                  disabled={
                    isLoading ||
                    (selectedGames.length === 0 && selectedLeagues.length === 0)
                  }
                  data-testid="next-button"
                />
                <button
                  className="px-8 py-3 text-[#0081F8] border border-[#0081F8] rounded-full hover:bg-blue-50 transition-colors"
                  onClick={skippingLeagueSelection}
                  disabled={isLoading}
                >
                  Skip
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
     {deviceType === "mobile" ?
              <MobileFooter /> :
               <FooterTab component="privacyPolicy" className="mt-auto" />
              }
    </div>
  );
};

export default Leagues;